import { c as _c } from "react/compiler-runtime";
import React from 'react';
const AffiliateProgramSettingsSkeleton = () => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="bg-skeleton-primary animate-pulse rounded-md text-transparent">.</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex flex-col gap-2">{t0}{" "}<div className="bg-skeleton-primary animate-pulse rounded-md text-transparent">.</div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="[&>*]:flex-1 flex w-full flex-col gap-7 xl:flex-row xl:items-end"><div className="bg-skeleton-primary my-3 animate-pulse rounded-md py-[11px] text-transparent">.</div><div className="bg-skeleton-primary my-3 animate-pulse rounded-md py-[11px] text-transparent">.</div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="bg-background-secondary [&>*]:flex-1 flex h-fit w-full flex-col gap-7 overflow-x-hidden rounded-md p-5">{t1}{t2}<div className="[&>*]:flex-1 flex w-full flex-col gap-7 xl:flex-row xl:items-end"><div className="bg-skeleton-primary my-3 animate-pulse rounded-md py-[11px] text-transparent">.</div><div className="bg-skeleton-primary my-3 animate-pulse rounded-md py-[11px] text-transparent">.</div></div><div className="bg-skeleton-primary my-3 animate-pulse rounded-md py-[11px] text-transparent">.</div><div className="bg-skeleton-primary animate-pulse rounded-md py-[1.5px] text-transparent">.</div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export default AffiliateProgramSettingsSkeleton;